import { Box } from '@mui/material';
import DeviceTableColumnContent from './BaseTableColumnContent';

export default function DeviceTableColumn({
    columnValue,
    children,
}: {
    columnValue?: string;
    children?: React.ReactNode;
}) {
    return (
        <Box
            // height={'100%'}
            sx={{
                pt: '10px',
                pb: '9px',
                minWidth: 0,
            }}
        >
            {columnValue ? <DeviceTableColumnContent columnValue={columnValue as string} /> : children}
        </Box>
    );
}
